import { render, staticRenderFns } from "./StepPriceDetail.vue?vue&type=template&id=2047e113&scoped=true&"
import script from "./StepPriceDetail.vue?vue&type=script&lang=js&"
export * from "./StepPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./StepPriceDetail.vue?vue&type=style&index=0&id=2047e113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047e113",
  null
  
)

export default component.exports